import storeManager from "../db_images/store_manager.png";
import talkerManager from "../db_images/talker_manager.png";
import blogsApi from "../db_images/blogs_api.png";
import smith from "../db_images/smith.png";
import cashforce from "../db_images/cashforce.png";
import futebolClube from "../db_images/futebol_clube.jpeg";
import pratas from "../db_images/pratas.png";
import gastos from "../db_images/gastos.png";


const projectsBackend = [
  {
    key: "gestaoFinanceira",
    image: `${gastos}`,
    link: "https://github.com/furquin/panilhaFinanceira",
  },
  {
    key: "ecommerceJoias",
    image: `${pratas}`,
    link: "https://github.com/furquin/backendPratas"
  },
  {
    key: "cashforce",
    image: `${cashforce}`,
    link: "https://github.com/furquin/cashforce",
  },
  {
    key: "futebolClube",
    image: `${futebolClube}`,
    link: "https://github.com/furquin/futebol-clube",
  },
  {
    key: "smith",
    image: `${smith}`,
    link: "https://github.com/furquin/smith",
  },
  {
    key: "blogApi",
    image: `${blogsApi}`,
    link: "https://github.com/furquin/blogs-api",
  },
  {
    key: "talkerManager",
    image: `${talkerManager}`,
    link: "https://github.com/furquin/talker-manager",
  },
  {
    key: "storeManager",
    image: `${storeManager}`,
    link: "https://github.com/furquin/store-manager",
  },
];

export default projectsBackend;
